import {
  Component,
  Inject,
  Input,
  OnInit,
  forwardRef
} from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';

import { ForPaymentSettingsModel } from './typings/vendor-invoices.for-payment.settings';
import { InvoiceModel }            from '../invoices/models/invoice';
import { Table }                   from '../table/types/table';
import { TableQueryParameters }    from '../table/types/table-query-parameters';
import { TableService }            from '../table/table.service';
import { VendorPaymentsService }   from '../vendor-payments/vendor-payments.service';
import { VendorModel }             from '../vendors/models/vendor';

@Component({
  selector   : 'wor-vendor-invoices-for-payment',
  template: require('./vendor-invoices.for-payment.component.html')
})
export class VendorInvoicesForPaymentComponent implements OnInit {
  @Input() invoices: Array<any>;
  @Input() settings: ForPaymentSettingsModel;
  @Input() vendor  : VendorModel;

  areAllSelected            = false;
  selectedItems: Array<any> = [];

  tableSettings : Table;

  constructor (
    public  activeModal         : NgbActiveModal,
    @Inject(forwardRef(() => TableService)) private tableService        : TableService,
    private translateService    : TranslateService,
    @Inject(forwardRef(() => VendorPaymentsService)) private vendorPaymentsService: VendorPaymentsService
  ) {}

  ngOnInit () : void {
    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.settings.tableCacheKey
      },
      columns: [
        {
          classes: 'text-left',
          field  : 'vendor_invoice_number',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
          }
        },
        {
          classes: 'text-left',
          field  : 'post_date',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
          },
          pipe: 'globalDate'
        },
        {
          classes: 'text-left',
          field  : 'total',
          header : {
            text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
          },
          pipe: 'globalCurrency'
        },
        {
          classes: 'text-left',
          field  : 'balance_due',
          header : {
            text: this.translateService.instant('JS_SPACE.COLUMNS.BALANCE')
          },
          pipe: 'globalCurrency'
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true,
          multi  : true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.settings.tableCacheKey, {
        direction: 'desc',
        enabled  : true,
        field    : 'post_date'
      }),
      static: true
    };
  }

  getInvoices ( params : TableQueryParameters ) : void {
    const isBranchPayment = this.settings.isBranchPayment || false;

    this.vendorPaymentsService.getInvoicesForPayment(this.vendor, params, isBranchPayment)
    .then(( invoices : Array<InvoiceModel> ) => {
      this.invoices = invoices;
    });
  }

  handleInvoiceSelection () : void {
    this.selectedItems = this.invoices.filter(invoice => invoice.selected);

    this.areAllSelected = this.invoices.length === this.selectedItems.length;
  }

  toggleAll () : void {
    this.invoices.forEach(invoice => {
      invoice.selected = !this.areAllSelected;
    });

    this.areAllSelected = !this.areAllSelected;
    this.selectedItems  = this.areAllSelected
      ? this.invoices
      : [];
  }
}
